import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/store/auth/auth';

const routes = [
  { path: '/', name: 'login', component: () => import('../views/Login.vue') },
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/RecoverPassword',
    name: 'RecoverPassword',
    component: () => import('../views/RecoverPassword.vue')
  },
  {
    path: '/merchant',
    component: () => import('../views/MainTPL.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('../views/Dashboard.vue')
      },
      {
        path: 'reports',
        name: 'reports',
        component: () => import('../views/Reports.vue')
      },
      {
        path: 'cash-register',
        name: 'cashRegister',
        component: () => import('../views/cashRegister.vue')
      },
      {
        path: 'changue-password',
        name: 'changuePassword',
        component: () => import('../views/changuePassword.vue')
      },
      {
        path: 'users',
        name: 'users',
        component: () => import('../views/users/users.vue')
      },
      {
        path: 'edit-users',
        name: 'editUsers',
        component: () => import('../views/users/editUsers.vue')
      },
      {
        path: 'add-users',
        name: 'addUsers',
        component: () => import('../views/users/createUser.vue')
      },
      {
        path: 'profiles',
        name: 'profiles',
        component: () => import('../views/profile/profiles.vue')
      },
      {
        path: 'edit-profile',
        name: 'editProfile',
        component: () => import('../views/profile/editProfile.vue')
      },
      {
        path: 'add-prodile',
        name: 'createProfile',
        component: () => import('../views/profile/createProfile.vue')
      },
      {
        path: 'bitacora',
        name: 'bitacora',
        component: () => import('../views/bitacora/bitacora.vue')
      },
      {
        path: 'catalogs',
        name: 'catalogs',
        component: () => import('../views/catalogs/query.vue')
      },
      {
        path: 'tpvs',
        name: 'tpvs',
        component: () => import('../views/catalogs/tpvs.vue')
      },
      {
        path: 'institutions',
        name: 'institutions',
        component: () => import('../views/catalogs/institutions.vue')
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  const token = localStorage.getItem('token');
  if (to.path === '/auth' && to.query.token) {
    localStorage.setItem('token', String(to.query.token));
    authStore.setToken(String(to.query.token));

    return next({ name: 'dashboard' });
  }

  if (token && !authStore.isAuthenticated) {
    authStore.setToken(token);
  }

  if (to.fullPath.includes('merchant')) {
    if (authStore.isAuthenticated || token) {
      next();
    } else {
      next({ name: 'login' });
    }
  } else {
    next();
  }
});

export default router;
